import React from 'react';
import AtlasV2DoubleDropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DoubleDropdownMetricColumnChart';
import { HIDE_GROUP_BY_LEVEL } from 'src/components/Layout/AtlasV2PageLayout';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 *
 * Sales Summary double dropdown
 */
const AtlasV2SalesDoubleDropdownTopEntityChart = () => {
  const mainEntityType = useMainEntityType();

  return (
    <AtlasV2DoubleDropdownMetricColumnChart
      fields={[
        { fieldName: 'retailSales', label: 'Retail Sales' },
        { fieldName: 'onePSales', label: '1P Retail Sales' },
        { fieldName: 'threePSales', label: '3P Retail Sales' }
      ]}
      groupByFields={[
        {
          id: 'brandId',
          label: 'Brand',
          indexName: 'sales'
        },
        {
          id: 'categoryId',
          label: 'Category',
          indexName: 'sales'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory',
          indexName: 'sales'
        },

        {
          id: 'parentBrandId',
          label: 'Manufacturer',
          indexName: 'sales'
        }
      ].filter(
        (option) =>
          !option.id.toLowerCase().startsWith(mainEntityType) &&
          HIDE_GROUP_BY_LEVEL?.[mainEntityType]?.[option.id] !== true
      )}
    />
  );
};

export default AtlasV2SalesDoubleDropdownTopEntityChart;
